import { BackgroundColor } from '@ampcore/ampcom-contracts'

/** The background palette the carousel supports. */
export const carouselBackgroundColors = [
  BackgroundColor.WHITE,
  BackgroundColor.STONE,
  BackgroundColor.AMERIPRISE_BLUE,
  BackgroundColor.MIDNIGHT_BLUE
] as const

export type CarouselBackgroundColor = (typeof carouselBackgroundColors)[number]

export type CarouselBackgroundClasses = {
  bgClass: string
  /** Content contrast class; controls text and control colors. */
  contrastClass: string
}
